(function () {
  const sectionSelector = '.free-gift-accessories-showcase';
  const carouselSelector = '[data-fgas-carousel]';

  const initCarousel = (root) => {
    if (!root || root.dataset.fgasInitialized === 'true') return;

    const carousel = root.querySelector(carouselSelector);
    const viewport = root.querySelector('[data-fgas-viewport]');
    const track = root.querySelector('[data-fgas-track]');
    const prevButton = root.querySelector('[data-fgas-prev]');
    const nextButton = root.querySelector('[data-fgas-next]');
    const pagination = root.querySelector('[data-fgas-pagination]');

    if (!carousel || !viewport || !track || !prevButton || !nextButton || !pagination) return;

    root.dataset.fgasInitialized = 'true';

    const isTwoItems = carousel.classList.contains('free-gift-accessories-showcase__carousel--two-items');
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const originalItems = [...track.children];
    let beforeItems = [];
    let afterItems = [];
    let loopEnabled = false;

    let positions = [0];
    let currentIndex = 0;
    let originalStart = 0;
    let originalGroupWidth = 0;
    let originalMaxOffset = 0;
    let isLooping = false;
    let isAnimating = false;
    let transitionFrame = 0;
    let transitionTimer = 0;
    let trackPosition = 0;
    let activeTransitionHandler = null;

    const cloneItem = (item) => {
      const clone = item.cloneNode(true);
      clone.classList.add('is-fgas-clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-bl-reveal-item');
      clone.removeAttribute('data-bl-reveal-order');
      clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
      clone.querySelectorAll('[data-bl-reveal-item]').forEach((element) => {
        element.removeAttribute('data-bl-reveal-item');
        element.removeAttribute('data-bl-reveal-order');
      });
      return clone;
    };

    const enableLoop = () => {
      if (loopEnabled || isTwoItems || originalItems.length < 2) return;

      const beforeFragment = document.createDocumentFragment();
      const afterFragment = document.createDocumentFragment();
      beforeItems = [];
      afterItems = [];

      originalItems.forEach((item) => {
        const beforeClone = cloneItem(item);
        const afterClone = cloneItem(item);
        beforeItems.push(beforeClone);
        afterItems.push(afterClone);
        beforeFragment.appendChild(beforeClone);
        afterFragment.appendChild(afterClone);
      });

      track.insertBefore(beforeFragment, track.firstChild);
      track.appendChild(afterFragment);
      loopEnabled = true;
    };

    const disableLoop = () => {
      if (!loopEnabled) return;

      track.querySelectorAll('.is-fgas-clone').forEach((clone) => clone.remove());
      beforeItems = [];
      afterItems = [];
      loopEnabled = false;
    };

    if (mobileQuery.matches) enableLoop();

    const setTrackPosition = (position) => {
      trackPosition = position;
      track.style.transform = `translate3d(${-position}px, 0, 0)`;
    };

    const clearTransition = () => {
      window.cancelAnimationFrame(transitionFrame);
      window.clearTimeout(transitionTimer);
      if (activeTransitionHandler) {
        track.removeEventListener('transitionend', activeTransitionHandler);
        activeTransitionHandler = null;
      }
    };

    const jumpToPosition = (position) => {
      clearTransition();
      isAnimating = false;
      track.style.transition = 'none';
      setTrackPosition(position);
      track.offsetHeight;
      track.style.transition = '';
    };

    const animateToPosition = (target, callback) => {
      clearTransition();

      if (Math.abs(target - trackPosition) < 0.5) {
        callback?.();
        return;
      }

      isAnimating = true;

      const finish = () => {
        if (activeTransitionHandler) {
          track.removeEventListener('transitionend', activeTransitionHandler);
          activeTransitionHandler = null;
        }
        window.clearTimeout(transitionTimer);
        isAnimating = false;
        callback?.();
      };

      const handleTransitionEnd = (event) => {
        if (event.target !== track || event.propertyName !== 'transform') return;
        finish();
      };

      activeTransitionHandler = handleTransitionEnd;
      track.addEventListener('transitionend', handleTransitionEnd);
      transitionFrame = window.requestAnimationFrame(() => {
        setTrackPosition(target);
      });
      transitionTimer = window.setTimeout(finish, 520);
    };

    const setHidden = (element, isHidden) => {
      element.classList.toggle('is-hidden', isHidden);
      if (isHidden) {
        element.setAttribute('aria-hidden', 'true');
      } else {
        element.removeAttribute('aria-hidden');
      }
    };

    const updateControls = () => {
      const hasPages = positions.length > 1;

      setHidden(prevButton, !hasPages);
      setHidden(nextButton, !hasPages);
      setHidden(pagination, !hasPages);

      prevButton.disabled = !hasPages;
      nextButton.disabled = !hasPages;

      pagination.querySelectorAll('[data-fgas-dot]').forEach((dot, index) => {
        const isActive = index === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const setEdgeState = (state) => {
      carousel.classList.remove(
        'is-fgas-forward',
        'is-fgas-forward-end',
        'is-fgas-backward',
        'is-fgas-backward-start'
      );

      if (state) {
        carousel.classList.add(`is-fgas-${state}`);
      }
    };

    const scrollToIndex = (index) => {
      if (!mobileQuery.matches || positions.length < 1 || isAnimating) return;

      const direction = index < currentIndex ? 'backward' : 'forward';
      const isForwardLoop = loopEnabled && positions.length > 1 && index >= positions.length;
      const isBackwardLoop = loopEnabled && positions.length > 1 && index < 0;
      const nextIndex = Math.max(0, Math.min(index, positions.length - 1));

      if (isForwardLoop) {
        setEdgeState('forward');
      } else if (isBackwardLoop) {
        setEdgeState('backward');
      } else if (direction === 'forward' && nextIndex === positions.length - 1) {
        setEdgeState('forward-end');
      } else if (direction === 'backward' && nextIndex === 0) {
        setEdgeState('backward-start');
      } else {
        setEdgeState(direction);
      }

      window.requestAnimationFrame(() => {
        calculatePositions(false);

        if (isForwardLoop) {
          const loopTarget = afterItems[0]?.offsetLeft;
          if (typeof loopTarget !== 'number') return;

          isLooping = true;
          currentIndex = 0;
          updateControls();
          animateToPosition(loopTarget, () => {
            jumpToPosition(positions[0]);
            isLooping = false;
            updateControls();
          });
          return;
        }

        if (isBackwardLoop) {
          const loopTarget = (beforeItems[0]?.offsetLeft ?? 0) + originalMaxOffset;

          isLooping = true;
          currentIndex = positions.length - 1;
          updateControls();
          animateToPosition(loopTarget, () => {
            jumpToPosition(positions[positions.length - 1]);
            isLooping = false;
            updateControls();
          });
          return;
        }

        currentIndex = nextIndex;
        updateControls();
        animateToPosition(positions[nextIndex]);
      });
    };

    const renderDots = () => {
      pagination.innerHTML = '';

      positions.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'free-gift-accessories-showcase__dot';
        dot.setAttribute('data-fgas-dot', '');
        dot.setAttribute('aria-label', `Go to free gift page ${index + 1}`);
        dot.addEventListener('click', () => scrollToIndex(index));
        pagination.appendChild(dot);
      });
    };

    const calculatePositions = (shouldSnap = true) => {
      const previousIndex = currentIndex;
      const pageWidth = viewport.clientWidth;
      const firstOriginal = originalItems[0];
      const lastOriginal = originalItems[originalItems.length - 1];

      if (!firstOriginal || !lastOriginal) return;

      originalStart = firstOriginal.offsetLeft;
      originalGroupWidth = lastOriginal.offsetLeft + lastOriginal.offsetWidth - originalStart;
      originalMaxOffset = Math.max(0, originalGroupWidth - pageWidth);

      positions = [originalStart];

      if (mobileQuery.matches && originalMaxOffset > 1 && pageWidth > 0) {
        let position = pageWidth;

        while (position < originalMaxOffset - 1) {
          positions.push(Math.round(originalStart + position));
          position += pageWidth;
        }

        positions.push(Math.round(originalStart + originalMaxOffset));
      }

      currentIndex = mobileQuery.matches ? Math.min(previousIndex, positions.length - 1) : 0;
      renderDots();
      if (shouldSnap) {
        jumpToPosition(positions[currentIndex]);
      }
      updateControls();
    };

    prevButton.addEventListener('click', () => scrollToIndex(currentIndex - 1));
    nextButton.addEventListener('click', () => scrollToIndex(currentIndex + 1));

    const setPreviousVisibility = (isVisible) => {
      prevButton.classList.toggle('is-visible', isVisible);
      prevButton.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      prevButton.tabIndex = isVisible ? 0 : -1;
    };

    setPreviousVisibility(mobileQuery.matches);

    const handleViewportModeChange = (event) => {
      clearTransition();
      isAnimating = false;

      if (event.matches) {
        enableLoop();
        setEdgeState('backward-start');
      } else {
        disableLoop();
        setEdgeState('');
      }

      currentIndex = 0;
      setPreviousVisibility(event.matches);
      calculatePositions();
    };

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleViewportModeChange);
    } else {
      mobileQuery.addListener(handleViewportModeChange);
    }

    const handleResize = () => {
      calculatePositions(!isAnimating);
    };

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(viewport);
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', handleResize);
    }

    calculatePositions();
  };

  const initSections = (scope = document) => {
    scope.querySelectorAll(sectionSelector).forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSections());
  } else {
    initSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSections(event.target);
  });
})();
